import { Component, DestroyRef, inject, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { showSpinner, TypedRoute } from '@shared/utils';
import { AuthService } from '@core/auth';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss',
})
export class OnboardingComponent {
  destroyRef = inject(DestroyRef);
  constructor(
    @Inject(ActivatedRoute) private route: TypedRoute<{ token: string }>,
    private authService: AuthService,
  ) {
    this.route.data.subscribe((data) => {
      if (data.token) {
        this.authService
          .verifySignupJWT(data.token)
          .pipe(showSpinner())
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (data) => {
              this.authService.logIn(data.key, '/onboarding/finish');
            },
            error: (error: HttpErrorResponse) => {
              this.authService.showTokenVerifyErrorToast(error);
            },
          });
      }
    });
  }
}
